const getters = {
  urtoken: state => state.user.urtoken,
  uxtoken: state => state.user.uxtoken,
  userid: state => state.user.userid,
  username: state => state.user.username,
  useraddr: state => state.user.useraddr,
  orgname: state => state.user.orgname,
  orgaddr: state => state.user.orgaddr
}
export default getters
